import Radio from "@mui/material/Radio";

const RadioButtonComponent = ({
  options = [],
  selectedValue,
  onChange,
  name = "radio-group",
  className = "",
}) => {
  const handleSelect = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: () => handleSelect(item),
    value: item,
    name: name,
    inputProps: { "aria-label": item },
  });

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {options.map((option, index) => {
        const value = typeof option === "string" ? option : option.value;
        const label = typeof option === "string" ? option : option.label;

        return (
          <div
            key={`${value}-${index}`}
            className={`w-full px-3 py-3 flex items-center justify-start border rounded-xl gap-2 cursor-pointer ${
              selectedValue === value
                ? "bg-[#FFF8F5] border-card-width border-[#F46C3C]"
                : "bg-white border-card-width  border-[#D9D9D9]"
            }`}
            onClick={() => handleSelect(value)}
          >
            <Radio
              {...controlProps(value)}
              sx={{
                color: "#D9D9D9",
                "&.Mui-checked": {
                  color: "#F46C3C",
                },
                transform: "scale(0.75)",
                padding: "0px",
              }}
            />
            <span className="flex items-center text-sm font-medium">{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default RadioButtonComponent;
